import { Roles } from 'model';
import { useCurrentUser } from './useCurrentUser.js';

export function useUserHasRole(role: Roles) {
	return useCurrentUser()?.roles.includes(role);
}

export function useUserHasAllRoles(roles: Roles[]): boolean {
	const user = useCurrentUser();
	return roles.every(role => user.roles.includes(role));
}

export function useUserHasSomeRoles(roles: Roles[]): boolean {
	const user = useCurrentUser();
	return roles.some(role => user.roles.includes(role));
}
